import 'babel-polyfill';
import Vue from 'vue';
import { Plugin } from 'vue-fragment';
import VueTheMask from 'vue-the-mask';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import _ from 'lodash';
import App from './App.vue';
import router from './router';
import store from './store/index';
import vuetify from './plugins/vuetify';
import i18n from './i18n';
import { GOOGLE_MAPS_API_KEY } from './plugins/mapSettings';
import { CHECK_AUTH } from './store/mutations.type';
import storeStyle from './styles/stores.css';
import websiteStyle from './styles/website.css';
import samsungStyle from './styles/samsung.css';
import huaweiStyle from './styles/huawei.css';
import slider from './styles/slider.css';
import * as syP from '@/utils/systemParams';
import selectField from '@/mixins/selectField.js';


// Layout loader
import InternalLayout from './layouts/InternalLayout.vue';
import OuterLayout from './layouts/OuterLayout.vue';
import SamsungLayout from './layouts/SamsungLayout.vue';
import HuaweiLayout from './layouts/HuaweiLayout.vue';

// eslint-disable-next-line no-unused-vars

Vue.config.productionTip = false;

Vue.component('outer-layout', OuterLayout);
Vue.component('internal-layout', InternalLayout);
Vue.component('samsung-layout', SamsungLayout);
Vue.component('huawei-layout', HuaweiLayout);

Vue.use(Plugin);
Vue.use(VueTheMask);
Vue.use(VueReCaptcha, { siteKey: '6Ld7NeIUAAAAALb17LAS3QW-bHse8q34QbFOy4ab' });

const defaultInternal = '/planner';
const defaultOuter = '/login';
/* router.beforeEach(async (to, from, next) => {
  await store.dispatch(CHECK_AUTH);
  if (store.state.auth.isAuthenticated) {
    if (to.meta.layout === 'outer') {
      next(defaultInternal);
    } else {
      next();
    }
  } else if (to.meta.layout === 'outer') {
    next();
  } else {
    next(defaultOuter);
  }
}); */

new Vue({
  router,
  store,
  vuetify,
  i18n,
  _,
  render: h => h(App),
}).$mount('#app');
